((root)=>{
    const STORAGE_KEY = 'taler-theme';
    function applyTheme(theme) {
        const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
        const dark = theme === 'dark' || theme === 'system' && prefersDark;
        root.classList.toggle('dark', dark);
    }
    const stored = localStorage.getItem(STORAGE_KEY);
    applyTheme(stored ?? 'system');
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', ()=>{
        if (!localStorage.getItem(STORAGE_KEY)) applyTheme('system');
    });
    function initToggle() {
        document.querySelectorAll('[data-theme-toggle]').forEach((btn)=>{
            btn.addEventListener('click', ()=>{
                const isDark = root.classList.contains('dark');
                const next = isDark ? 'light' : 'dark';
                localStorage.setItem(STORAGE_KEY, next);
                applyTheme(next);
            });
        });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initToggle);
    else initToggle();
})(document.documentElement);

//# sourceMappingURL=theme-toggle.f5aed770.js.map
